import i18n from "@/i18n";
import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { RequestsStates } from "../../data/enums/requestsStates";
import { OperationRequestData } from "../../data/operationRequestData";
import { ActionModel } from "../ActionModel";

/** Модель операции */
export class OperationModel extends ActionModel {
  /**Код операции */
  public RespondentCode: string = "";

  /** Картинка операции в каталоге */
  public Picture: string = "";

  /**Заголовок операции */
  public Caption: string = "";

  public propertyErrorsComes: boolean = false;

  /**
   * Показывать данные операции перед проведением.
   */
  public IsNeedInfoBeforeExecute: boolean = false;

  /**
   * Описание операции.
   */
  public Description: string = "";

  /**
   * ИД операции.
   */
  public OperationId: number = 0;

  /**Обработка execute */
  public ExecuteLoading: boolean = false;

  /**Обработка prepare */
  public PrepareLoading: boolean = false;

  public operationStage: number | null = null;

  /**
   * Статус запроса.
   */
  public RequestState: RequestsStates = RequestsStates.None;

  constructor(respondentCode: string = "") {
    super();

    this.RespondentCode = respondentCode;
  }

  /**
   * Создание запроса операции.
   */
  public createOperationRequest(): OperationRequestData {
    const ord = new OperationRequestData();
    ord.respondentCode = this.RespondentCode;
    ord.operationId = this.OperationId;

    for (const key in this.Data) {
      ord.setProperty(key, this.Data[key], DeclarationPropertiesTypes.String);
    }

    return ord;
  }

  /**
   * Заполнение операции данными из ответа запроса.
   * @param ord Данные запроса.
   * @param bAssign Признак assign.
   */
  public setOperationFromRequest(...args: any[]): void {
    console.log("No implemetation");
  }

  /**Проверка реквизитов запроса */
  public checkProperties() {
    return true;
  }

  /**Детали операции */
  get details(): Array<any> {
    const details: Array<any> = [];

    for (const key in this.Data) {
      details.push(key, this.Data[key]);
    }

    return details;
  }

  /**Стиль статуса запроса */
  get requestStateStyle(): string {
    let style = "";
    if (this.IsSuccess) style = "success-icon";
    else if (this.IsExecuting) style = "wait-icon";
    else if (this.IsError) style = "error-icon";

    return style;
  }

  /**Текстовый статус запроса */
  get stringRequestState(): string {
    let stringState = "";
    if (this.IsSuccess)
      stringState = i18n.t("main.operation.form.stateExecuted").toString();
    else if (this.IsExecuting)
      stringState = i18n.t("main.operation.form.stateExecuting").toString();
    else if (this.IsError)
      stringState = `${i18n.t("main.operation.form.stateDenied").toString()}: ${
        this.ActionStateText
      }`;
    else stringState = i18n.t("main.operation.form.stateDenied").toString();

    return stringState;
  }
}
